import React, { useState } from "react";
import api from "../utils/axiosInstance";

function FeedbackPage() {

  const [form,setForm]=useState({
    name:"",
    email:"",
    rating:5,
    message:""
  });

  const submit = async(e)=>{

    e.preventDefault();

    await api.post("/api/feedback",form);

    alert("Thank you for your feedback!");

  };

  return(

    <div className="max-w-xl mx-auto p-10">

      <h1 className="text-4xl font-serif mb-6">
        Share Your Feedback
      </h1>

      <form onSubmit={submit} className="space-y-4">

        <input placeholder="Name" className="border p-3 w-full"
          onChange={(e)=>setForm({...form,name:e.target.value})}/>

        <input placeholder="Email" className="border p-3 w-full"
          onChange={(e)=>setForm({...form,email:e.target.value})}/>

        <select className="border p-3 w-full"
          onChange={(e)=>setForm({...form,rating:e.target.value})}>

          <option value="5">⭐⭐⭐⭐⭐</option>
          <option value="4">⭐⭐⭐⭐</option>
          <option value="3">⭐⭐⭐</option>
          <option value="2">⭐⭐</option>
          <option value="1">⭐</option>

        </select>

        <textarea placeholder="Your feedback"
          className="border p-3 w-full"
          onChange={(e)=>setForm({...form,message:e.target.value})}/>

        <button className="bg-purple-700 text-white px-6 py-3 rounded">
          Submit Feedback
        </button>

      </form>

    </div>

  )

}

export default FeedbackPage